import { log } from "~features/seated-reservation/helpers/stateLogger";
import { dontUnselectSeatsPrompt } from "~features/seated-reservation/helpers/userPrompt";
import { getZoneKeys } from "~features/seated-reservation/helpers/zoneFilters";
import { getState, setState, StoreState } from "../index";
import { selectBestSeats } from "./selectBestSeats";
import { ConvergeSdk } from "@seeka-labs/converge";

interface ActionProps {
  zone: StoreState["currentZone"];
}

export const setCurrentZone = async (
  payload: ActionProps,
  converge?: ConvergeSdk
) => {
  log("setCurrentZone", payload);

  const state = getState();

  const isGA = !payload.zone.sections?.length;

  if (dontUnselectSeatsPrompt(state.seats)) return;

  const currentZone = payload.zone || state.currentZone;
  const categoriesKeys = getZoneKeys(currentZone);

  setState({
    currentZone: currentZone,
    availableTicketTypes: currentZone.ticketTypes,

    // clear current section if selection a zone as it preceeds
    currentSection: undefined,

    sidebarIndex: currentZone.sections?.length > 0 ? 2 : 3,
  });

  if (isGA) {
    await selectBestSeats(
      {
        categoryKey: categoriesKeys,
      },
      converge
    );
  }
};
